import React from 'react';
import { Link } from 'react-router-dom';

const GeneralInformation = () => {
  return (
    <div className="container py-8">
      <div className="max-w-4xl mx-auto">
        {/* Mission Statement Section */}
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-4">Mission Statement</h2>
          <p className="mb-4">
            The mission of Hamilton College of the Bahamas is to provide the educational experience in an environment
            supportive of faith and learning that will encourage adult students to "discover their potential." Hamilton College
            makes high-quality professionally enhanced programs accessible to adults of diverse backgrounds and assists them
            to succeed in their careers and communities. Students are admitted to Hamilton College of the Bahamas without
            consideration of race, color, national origin, sex, or religion. All are encouraged to be faithful to their faith.
          </p>
          
          <p className="mb-4">The core values of the University include:</p>
          
          <ul className="list-disc pl-6 mb-4 space-y-2">
            <li>Academic quality - We are committed to effective adult learning and rigorous academic standards.</li>
            <li>Student success - We provide the opportunity and supportive learning environment that enables adults to achieve their professional and personal goals.</li>
            <li>Educational access - We believe all desiring and qualified adults have a right to higher education.</li>
            <li>Private and non-governmental - Hamilton College of the Bahamas is a private and non-governmental institution.</li>
          </ul>

          <div className="mt-4">
            <Link 
              to="/catalog/mission_statement" 
              className="inline-flex items-center text-primary-600 hover:text-primary-700"
            >
              Read our full Mission Statement
              <svg 
                className="ml-2 w-4 h-4" 
                fill="none" 
                stroke="currentColor" 
                viewBox="0 0 24 24"
              >
                <path 
                  strokeLinecap="round" 
                  strokeLinejoin="round" 
                  strokeWidth="2" 
                  d="M9 5l7 7-7 7"
                />
              </svg>
            </Link>
          </div>
        </section>

        {/* Educational Objectives Section */}
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-4">Educational Objectives</h2>
          <p className="mb-4">
            At Hamilton College of the Bahamas our goal is to provide a superior level of undergraduate and graduate education
            to working adult learners, who desire to advance their careers, start or grow a business, improve their job positions,
            and prepare for religious service.
          </p>
          
          <p className="mb-4">
            Hamilton College of the Bahamas is committed to excellence, respect for others, the distance learning model of
            education, and making our educational offerings affordable. Our goal is to offer our educational services at an
            affordable price by the use of conservative business practices, innovation, technology, and forward thinking.
          </p>
          
          <p className="mb-4">
            We realize that working professionals, due to life and career requirements, simply do not have the time to sit in a
            classroom. So we have designed our degree programs to work around our students' schedules. As such, we offer
            degree programs via distance learning.
          </p>
        </section>

        {/* Instructional Method Section */}
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-4">Instructional Method - Distance Learning (Internet)</h2>
          <p className="mb-4">
            Hamilton College of the Bahamas of the Americas is a religious-based, career-focused, distance learning school. Our
            courses are offered via the internet, by way of our educational software portal.
          </p>
        </section>

        {/* Residence and Time Requirements Section */}
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-4">Residence and Time Requirements</h2>
          <p className="mb-4">
            Since our programs are delivered via the internet, there is no classroom attendance required. However, in order to
            successfully complete any of our degree programs, a student should be prepared to devote at least 10-15 hours per
            week to their studies. In addition, most of our degree programs require missionary or ministry service.
          </p>
        </section>

        {/* Operating Authority Section */}
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-4">Operating Authority</h2>
          <p className="mb-4">
            Hamilton College of the Bahamas is approved by the Bahamian Government and has been recognized by the
            Ministry of Education.
          </p>
        </section>

        {/* Online Services and Library Facilities Section */}
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-4">Online Services and Library Facilities</h2>
          <p className="mb-4">
            Hamilton College of the Bahamas delivers its programs via the internet by way of an educational software portal. 
            We have developed a software educational delivery platform to handle our internet courses.
          </p>
          
          <p className="mb-4">
            Our educational portal may be accessed by any standard internet browser. Once admitted to our programs, students
            are given a unique username and password so that they may access the educational portal and begin their course.
            Also, Hamilton College of the Bahamas does not maintain a traditional library. We do, however, maintain an electronic
            library that is accessible by all of our students.
          </p>
        </section>

        {/* Statement of Legal Control Section */}
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-4">Statement of Legal Control</h2>
          <p className="mb-4">
            Hamilton College of the Bahamas of the Americas Bahamas is a registered corporation in the Bahamas. We are
            governed by an advisory board and headed by a President.
          </p>
          <p className="mb-4">The President of Hamilton College of the Bahamas is Dr. Jothi Jothishankar.</p>
        </section>

        {/* Catalog Navigation */}
        <nav className="mt-8 border-t pt-6">
          <ul className="space-y-2">
            <li>
              <Link to="/catalog/education_requirements" className="text-primary-600 hover:text-primary-700">
                Educational Requirements
              </Link>
            </li>
            <li>
              <Link to="/catalog/school_information" className="text-primary-600 hover:text-primary-700">
                School Information
              </Link>
            </li>
            <li>
              <Link to="/catalog/admissions" className="text-primary-600 hover:text-primary-700">
                Admissions
              </Link>
            </li>
            <li>
              <Link to="/catalog/tuition" className="text-primary-600 hover:text-primary-700">
                Tuition, Fees & Tools
              </Link>
            </li>
            <li>
              <Link to="/catalog/school_policy" className="text-primary-600 hover:text-primary-700">
                School Policies
              </Link>
            </li>
          </ul>
        </nav>
      </div>
    </div>
  );
};

export default GeneralInformation; 